module.exports = __webpack_public_path__ + "static/media/DK4055_05.3dbf3249.jpg";